const GAP = {
  SM: '4px',
  MD: '8px',
  LG: '16px',
  XLG: '20px',
  XL: '24px',
  XXL: '32px',
}

export default GAP
